import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
function useDragAndDropRef(dragAndDropRef) {
  const $ = _c(2);
  let t0;
  if ($[0] !== dragAndDropRef) {
    t0 = element => {
      if (element) {
        dragAndDropRef(element);
      }
    };
    $[0] = dragAndDropRef;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
export default useDragAndDropRef;